export const PageContentStyles = () => (
  <style>
    {`
            .image.image-style-side {
              position: relative;
              float: right;
              max-width: 50%;
              clear: both;
              min-width: 50px;
              display: table;
              text-align: center;
              margin: 0.9rem auto;
              margin-left: 20px;
            }

            .image img {
              margin-top: 20px;
              border-radius: 8px;
              overflow: hidden;
            }

            .table, 
            .table table {
                width: 100%;
            }

            .table img {
                cursor: pointer;
            }

            .table .image img {
                height: 150px;
                width: 150px;
            }

            @media only screen and (max-width: 768px) {
                .table .image img {
                    height: 110px;
                    width: 100px;
                }
            }

            @media only screen and (max-width: 500px) {
                .table .image img {
                    height: 85px;
                    width: 80px;
                }
            }
            :root {
                --ck-image-style-spacing: 1.5em;
                --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
            }
            .image-style-block-align-left,
            .image-style-block-align-right {
                max-width: calc(100% - var(--ck-image-style-spacing));
            }
            .image-style-align-left,
            .image-style-align-right {
                clear: none;
            }
            .image-style-side {
                float: right;
                margin-left: var(--ck-image-style-spacing);
                max-width: 50%;
            }
            .image-style-align-left {
                float: left;
                margin-right: var(--ck-image-style-spacing);
            }
            .image-style-align-center {
                margin-left: auto;
                margin-right: auto;
            }
            .image-style-align-right {
                float: right;
                margin-left: var(--ck-image-style-spacing);
            }
            .image-style-block-align-right {
                margin-right: 0;
                margin-left: auto;
            }
            .image-style-block-align-left {
                margin-left: 0;
                margin-right: auto;
            }
            /* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */
            p + .image-style-align-left,
            p + .image-style-align-right,
            p + .image-style-side {
                margin-top: 0;
            }
            .image-inline.image-style-align-left,
            .image-inline.image-style-align-right {
                margin-top: var(--ck-inline-image-style-spacing);
                margin-bottom: var(--ck-inline-image-style-spacing);
            }
            .image-style-align-left {
                margin-right: var(--ck-inline-image-style-spacing);
            }
            .image-style-align-right {
                margin-left: var(--ck-inline-image-style-spacing);
            }
        `}
  </style>
);
